import moment from 'moment-timezone';
import ngAnnotate from '../../../ngAnnotate.macro';
import template from './answering_time_settings.html';

angular.module('bb.admin').component('bbAnsweringTimeSettings', {
  bindings: {
    ignoreSettings: '<',
    toggling: '<',
  },
  controller: AnsweringTimeSettingsController,
  controllerAs: 'vm',
  template,
});

ngAnnotate(AnsweringTimeSettingsController);

function AnsweringTimeSettingsController(
  $scope,
  $q,
  ListingSearchService,
  AdminService,
  ToastService,
  ErrorService,
) {
  const vm = this;
  let defaultDaySetting;

  const resetSettings = () => {
    vm.specialDays = {};
    vm.timeSettings = {};

    const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const startTime = 0;
    defaultDaySetting = {};
    for (let timeInDay = startTime; timeInDay < 24; timeInDay++) {
      defaultDaySetting[`${timeInDay}:00`] = true;
      defaultDaySetting[`${timeInDay}:30`] = true;
    }
    days.forEach(day => {
      vm.timeSettings[day] = { ...defaultDaySetting };
    });
  };

  // Helper Functions
  const initializeSettings = (
    reducedSpecialDaysSettings,
    reducedWeeklySettings,
  ) => {
    Object.entries(reducedSpecialDaysSettings).forEach(([date, value]) => {
      vm.specialDays[date] = { ...defaultDaySetting };
      value.forEach(hour => {
        vm.specialDays[date][hour] = false;
      });
    });
    Object.entries(reducedWeeklySettings).forEach(([dayOfWeek, value]) => {
      value.forEach(hour => {
        vm.timeSettings[dayOfWeek][hour] = false;
      });
    });
  };

  const getFilteredHours = timeSettings =>
    Object.keys(timeSettings).reduce((acc, key) => {
      const filtered = [...acc];
      if (!timeSettings[key]) filtered.push(key);
      return filtered;
    }, []);

  const invertBeforeSaving = timeSettingsObject =>
    Object.keys(timeSettingsObject).reduce((acc, key) => {
      const filteredHours = getFilteredHours(timeSettingsObject[key]);
      acc[key] = filteredHours;
      return acc;
    }, {});

  const getTimeSettings = () => {
    vm.tsLoaded = false;
    resetSettings();
    AdminService.getAnsweringSettings(vm.selectedBranch)
      .then(({ weeklySettings, specialDays }) => {
        initializeSettings(specialDays, weeklySettings);
      })
      .finally(() => {
        vm.tsLoaded = true;
      });
  };

  vm.resetSpecialDay = () => {
    vm.specialDay = JSON.parse(JSON.stringify(defaultDaySetting));
  };

  vm.addSpecialDay = () => {
    vm.isDirty = true;
    vm.isSpecialDirty = false;
    const dayStr = moment(vm.selectedDate).format('YYYY-MM-DD');
    vm.specialDays[dayStr] = vm.specialDay;
    vm.resetSpecialDay();
  };

  vm.updateSpecialDay = time => {
    vm.isDirty = true;
    vm.isSpecialDirty = true;
    vm.specialDay[time] = !vm.specialDay[time];
  };

  vm.deleteSpecialDay = dayStr => {
    vm.isDirty = true;
    delete vm.specialDays[dayStr];
  };

  vm.updateWeeklySettings = (dayOfWeek, time) => {
    vm.isDirty = true;
    vm.timeSettings[dayOfWeek][time] = !vm.timeSettings[dayOfWeek][time];
  };

  vm.toggleWeekday = (dayOfWeek, bool) => {
    vm.isDirty = true;
    Object.keys(vm.timeSettings[dayOfWeek]).forEach(time => {
      vm.timeSettings[dayOfWeek][time] = bool;
    });
  };

  vm.toggleSpecialDay = bool => {
    vm.isDirty = true;
    vm.isSpecialDirty = true;
    Object.keys(vm.specialDay).forEach(time => {
      vm.specialDay[time] = bool;
    });
  };

  vm.saveSettings = () => {
    $q(resolve => {
      if (vm.isSpecialDirty) {
        swal(
          {
            title: 'Save Settings without Adding Special Day?',
            text: 'Please add the special day by clicking on "+ ADD SPECIAL DAY" for it to be saved',
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Save Anyways',
            cancelButtonText: 'Go Back',
          },
          confirm => {
            resolve(confirm);
          },
        );
      } else {
        resolve(true);
      }
    }).then(shouldSave => {
      if (!shouldSave) return;
      vm.tsLoaded = false;
      const reducedSpecialDaysSettings = invertBeforeSaving(vm.specialDays);
      const reducedWeeklySettings = invertBeforeSaving(vm.timeSettings);
      AdminService.saveAnsweringSettings(vm.selectedBranch, {
        weeklySettings: reducedWeeklySettings,
        specialDays: reducedSpecialDaysSettings,
      })
        .then(({ weeklySettings, specialDays }) => {
          ToastService.add({
            type: 'success',
            message: 'Settings saved successfully',
          });
          initializeSettings(specialDays, weeklySettings);
        })
        .catch(ErrorService.toastyHTTPErr)
        .finally(() => {
          vm.isDirty = false;
          vm.tsLoaded = true;
        });
    });
  };

  vm.branchChange = previousSelected => {
    if (vm.isDirty) {
      swal(
        {
          title: 'Changing Branch',
          text: 'Are you sure you want to change targeted branch without saving the settings?',
          html: true,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          closeButtonText: 'Go Back',
          closeOnConfirm: true,
        },
        confirm => {
          if (confirm) {
            vm.isDirty = false;
            getTimeSettings();
          } else {
            vm.selectedBranch = previousSelected;
          }
          $scope.$digest();
        },
      );
    } else {
      getTimeSettings();
    }
  };

  vm.cancel = () => {
    vm.tsLoaded = false;
    resetSettings();
    vm.resetSpecialDay();
    $q.all([
      AdminService.getAnsweringSettings(vm.selectedBranch),
      ListingSearchService.getLocations(),
    ])
      .then(([{ weeklySettings, specialDays }, { locationIndex }]) => {
        vm.locationIndex = locationIndex;
        initializeSettings(specialDays, weeklySettings);
      })
      .catch(ErrorService.toastyHTTPErr)
      .finally(() => {
        vm.tsLoaded = true;
      });
  };

  vm.$onInit = () => {
    resetSettings();
    vm.resetSpecialDay();
    vm.selectedBranch = '0';
    $q.all([
      AdminService.getAnsweringSettings(vm.selectedBranch),
      ListingSearchService.getLocations(),
    ])
      .then(([{ weeklySettings, specialDays }, { locationIndex }]) => {
        vm.locationIndex = locationIndex;
        initializeSettings(specialDays, weeklySettings);
      })
      .finally(() => {
        vm.loaded = true;
        vm.tsLoaded = true;
      });
  };
}
